import React, {useRef, useState, useEffect} from 'react';
import HeadSectionLogo from "./HeadSectionLogo";
import {NavLink} from "react-router-dom";
import Dropdown from "react-dropdown";
import {auth, logout} from "../../../actions/users";
import {useDispatch, useSelector} from "react-redux";
import AuthModal from "../../../sections/authSection/AuthModal";
import {RootState} from "../../../reducers/store";
import Drawer from '@mui/material/Drawer';
import { useTranslation } from "react-i18next";
import { languagesOption, STORE_LANGUAGE_KEY } from "../../../localization/i18n";

const OrderHeadSectionComponent = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);
    const { t, i18n } = useTranslation();
    const { language } = i18n;
    
    const [showNavMenu, setShowNavMenu] = useState(false);
    const [showSubmenu, setShowSubmenu] = useState(false);
    const blockRef = useRef<HTMLDivElement>(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [authType, setAuthType] = useState('' as string);
    const [width, setWidth]   = useState(window.innerWidth);
    
    const updateDimensions = () => {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    const toggleNavMenu = (newOpen: boolean) => {
        setShowNavMenu(newOpen);
    }
    
    useEffect(() => {
        const setLang = (lng: string) => {
            i18n.changeLanguage(lng).then(() => {
                document.documentElement.lang = lng;
            });
        };
        
        const storedLanguage = localStorage.getItem(STORE_LANGUAGE_KEY);
        
        if (storedLanguage) {
            setLang(storedLanguage);
        } else {
            setLang('no');
        }
    }, [i18n]);
    
    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng).then(() => {
            localStorage.setItem(STORE_LANGUAGE_KEY, lng);
            document.documentElement.lang = lng;
        });
    };

    const scrollToBlock = (blockClass: string) => {
        const block = document.querySelector(`.${blockClass}`);
        if (block) {
            block.scrollIntoView({ behavior: 'smooth' });
        }
    };


    const closeToggleNavMenu = () => {
        setShowNavMenu(false);
        const mainSectionNav = document.querySelector('.mainSectionComponent__container-content-overlay');
        if (mainSectionNav) {
            mainSectionNav.classList.remove('active');
        }
    }

    const handleLogout = async () => {
        closeToggleNavMenu();
        const mainSection = document.querySelector('.mainSectionComponent__container-content-overlay');

        if (mainSection) {
            mainSection.classList.remove('active');
        }
        try {
            //const logoutFunc = async () => {
            /*const response = await fetch("http://localhost:5000/api/auth/logout", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
            });
            const content = await response.json();
            console.log("logout content: ", content);
            if (content) {
                alert("successfully logout");
            }*/

            const response = await logout(dispatch);
            console.log("logout response: ", response);
            if (response) {
                alert("successfully logout");
            }
            //}
        } catch (e) {
            console.log("error e: ", e);
        }
    }

    const showCustomNavbarDisplay = () => {
        const navElements = document.querySelector('.authNavbar__container-nav-elements');
        const navLogo = document.querySelector('.authNavbar__container-logo');

        if (navElements && navLogo) {
            // navElements.setAttribute('style', 'z-index: 1301');
            navLogo.setAttribute('style', 'z-index: 1301');
        }
    }

    const handleLogin = (type: string) => {
        setAuthType(type);
        closeToggleNavMenu();
        setModalVisible(true);
        showCustomNavbarDisplay();
    }

    const handleCloseForm = (status: boolean) => {
        if (status) {
            // setIsAuthUser(status);
        }
    }

    return (
        <div className="orderHeadSection__container headSection">
            <div className="orderHeadSection__container_content headSection">
                <HeadSectionLogo />
                <div
                    className={`orderHeadSection__container_content_elements ${user.isAuth ? 'auth' : 'notAuth'}`}
                    ref={showNavMenu ? blockRef : null}
                >
                    <div className={`orderHeadSection__container_content_elements_search`}>
                        <input
                          className="orderHeadSection__container_content_elements_search_input"
                          type="text"
                          placeholder={t('main.searchForFood')}
                        />
                        <div className="orderHeadSection__container_content_elements_search_icon">
                            <img
                              src={process.env.PUBLIC_URL + '/images/magnifier.svg'}
                              alt="magnifier icon"
                            />
                        </div>
                    </div>
                    
                    {
                        user.isAuth ? (
                            <ul className={`orderHeadSection__container_content_elements_close auth`}>
                                {/* <li>
                                    <NavLink to="/#"
                                             onClick={(e) => e.preventDefault()}
                                    >
                                        <img
                                            className="magnifierIcon"
                                            src={process.env.PUBLIC_URL + '/images/magnifier.svg'}
                                            alt="magnifier icon"
                                        />
                                    </NavLink>
                                </li> */}
                                <li>
                                    <NavLink to="/profile" >
                                        <img
                                            className="authNavbar__container-nav-elements-img-account headSection"
                                            src={process.env.PUBLIC_URL + '/images/accountIcon.svg'}
                                            alt="account icon"
                                        />
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/cart" >
                                        <div className="authNavbarComponent__container_close_icon cart">
                                            <img
                                              src={process.env.PUBLIC_URL + '/images/shopping-cart.svg'}
                                              alt="cart icon"
                                            />
                                            <div className={`authNavbarComponent__container_close_icon_counter ${user?.cartCount > 9 ? 'large' : ''}`}>
                                                <span>{user?.cartCount || 0}</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/my-codes" >
                                        <div className="authNavbarComponent__container_close_icon qr">
                                            <img
                                              className="authNavbar__container-nav-elements-img-qr-code"
                                              src={process.env.PUBLIC_URL + '/images/qr-code.svg'}
                                              alt="qr code icon"
                                            />
                                            <div className={`authNavbarComponent__container_close_icon_counter ${user?.qrCodeCount > 9 ? 'large' : ''}`}>
                                                <span>{user?.qrCodeCount || 0}</span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>
                                <li>
                                    <div className="authNavbarComponent__container_languages dropdown">
                                        <Dropdown
                                          className="authNavbarComponent__container_languages_dropdown"
                                          arrowClosed={
                                              <div className="authNavbarComponent__container_languages_dropdown_icon close">
                                                  <img
                                                    src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                    alt="arrow closed"
                                                  />
                                              </div>
                                          }
                                          arrowOpen={
                                              <div className="authNavbarComponent__container_languages_dropdown_icon open">
                                                  <img
                                                    src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                    alt="arrow opened"
                                                  />
                                              </div>
                                          }
                                          options={languagesOption}
                                          onChange={(e) => changeLanguage(e.value)}
                                          value={language}
                                        />
                                    </div>
                                </li>
                                <li className="orderHeadSection__container_content_elements_close_burger">
                                    <img
                                        src={process.env.PUBLIC_URL + '/images/burgerMenu.svg'}
                                        alt="burger menu icon"
                                        onClick={() => toggleNavMenu(true)}
                                    />
                                </li>
                            </ul>
                        ) : (
                            <ul className={`orderHeadSection__container_content_elements_close notAuth`}>
                                {/* <li>
                                    <NavLink to="/#"
                                             onClick={(e) => e.preventDefault()}
                                    >
                                        <img
                                          className="magnifierIcon"
                                            src={process.env.PUBLIC_URL + '/images/magnifier.svg'}
                                            alt="magnifier icon"
                                        />
                                    </NavLink>
                                </li> */}

                                <li>
                                    <span onClick={() => handleLogin('registration')}>
                                        {t('navbar.signUp')}
                                    </span>
                                </li>
                                <li>
                                    <span
                                        onClick={() => handleLogin('login')}
                                    >
                                        {t('navbar.logIn')}
                                    </span>
                                </li>
                                <li>
                                    <div className="authNavbarComponent__container_languages dropdown">
                                        <Dropdown
                                          className="authNavbarComponent__container_languages_dropdown"
                                          arrowClosed={
                                              <div className="authNavbarComponent__container_languages_dropdown_icon close">
                                                  <img
                                                    src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                    alt="arrow closed"
                                                  />
                                              </div>
                                          }
                                          arrowOpen={
                                              <div className="authNavbarComponent__container_languages_dropdown_icon open">
                                                  <img
                                                    src={process.env.PUBLIC_URL + "/images/language-select-arrow.svg"}
                                                    alt="arrow opened"
                                                  />
                                              </div>
                                          }
                                          options={languagesOption}
                                          onChange={(e) => changeLanguage(e.value)}
                                          value={language}
                                        />
                                    </div>
                                </li>
                                <li className="authNavbar__container-nav-menu-icon-auth headSection">
                                    <img
                                      className="authNavbar__container-nav-menu-icon-img headSection"
                                      src={process.env.PUBLIC_URL + '/images/burgerMenu.svg'}
                                      alt="burger menu icon"
                                      onClick={() => toggleNavMenu(true)}
                                    />
                                </li>
                            </ul>
                        )
                    }
                    
                    <Drawer
                      anchor={'right'}
                      open={showNavMenu}
                      onClose={() => toggleNavMenu(false)}
                      className="headSidebar"
                    >
                        <div className="headSidebar__container">
                            {
                                user.isAuth && width > 424 ? (
                                    <ul className={`headSidebar__container_content auth`}>
                                        <li className={`${user?.address ? 'active' : 'default'}`} style={{ animationDelay: "0s" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M12 21C12 21 18 14.7 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 14.7 12 21 12 21Z" stroke="#8E8E8E"/>
                                                <path fillRule="evenodd" clipRule="evenodd" d="M12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10Z" stroke="#8E8E8E"/>
                                            </svg>
                                            <span>{user?.address || "street name"}</span>
                                        </li>
                                        <li style={{ animationDelay: "0s" }}>
                                            <NavLink to="/how-it-works"
                                                     onClick={() => {
                                                         //scrollToBlock('linkSection__container');
                                                         closeToggleNavMenu();
                                                     }}
                                            >{t('navbar.howItWorks')}</NavLink>
                                        </li>
                                        <li style={{ animationDelay: "0.2s" }}>
                                            <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                        </li>
                                        <li style={{ animationDelay: "0.4s" }}>
                                            <NavLink to="/help-with-order" >{t('navbar.helpWithOrder')}</NavLink>
                                        </li>
                                        <li style={{ animationDelay: "0.6s" }}>
                                            <NavLink to="/contact-us" >{t('navbar.contactUs')}</NavLink>
                                        </li>
                                        <li style={{ animationDelay: "0.8s" }}>
                                            <NavLink
                                              to="/"
                                              onClick={handleLogout}
                                            >{t('navbar.logOut')}</NavLink>
                                        </li>
                                    </ul>
                                  )
                                  :
                                  user.isAuth && width < 425 ? (
                                      <ul className={`headSidebar__container_content auth`}>
                                          <li className={`${user?.address ? 'active' : 'default'}`} style={{ animationDelay: "0s" }}>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                  <path fillRule="evenodd" clipRule="evenodd" d="M12 21C12 21 18 14.7 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 14.7 12 21 12 21Z" stroke="#8E8E8E"/>
                                                  <path fillRule="evenodd" clipRule="evenodd" d="M12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55228 11.4477 10 12 10Z" stroke="#8E8E8E"/>
                                              </svg>
                                              <span>{user?.address || "street name"}</span>
                                          </li>
                                          <li style={{ animationDelay: "0s" }}>
                                              <NavLink to="/profile"
                                                       onClick={() => {
                                                           //scrollToBlock('linkSection__container');
                                                           closeToggleNavMenu();
                                                       }}
                                              >{t('navbar.profile')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.1s" }}>
                                              <NavLink to="/cart" >
                                                  {t('navbar.cart')}
                                                  <div className={`authNavbarComponent__container_close_icon_counter ${user?.cartCount > 9 ? 'large' : ''}`}>
                                                      <span>{user?.cartCount || 0}</span>
                                                  </div>
                                              </NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.2s" }}>
                                              <NavLink to="/my-codes" >
                                                  {t('navbar.myCodes')}
                                                  <div className={`authNavbarComponent__container_close_icon_counter ${user?.qrCodeCount > 9 ? 'large' : ''}`}>
                                                      <span>{user?.qrCodeCount || 0}</span>
                                                  </div>
                                              </NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.3s" }}>
                                              <NavLink to="/how-it-works"
                                                       onClick={() => {
                                                           //scrollToBlock('linkSection__container');
                                                           closeToggleNavMenu();
                                                       }}
                                              >{t('navbar.howItWorks')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.4s" }}>
                                              <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.5s" }}>
                                              <NavLink to="/help-with-order" >{t('navbar.helpWithOrder')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.6s" }}>
                                              <NavLink to="/contact-us" >{t('navbar.contactUs')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.7s" }}>
                                              <NavLink
                                                to="/"
                                                onClick={handleLogout}
                                              >{t('navbar.logOut')}</NavLink>
                                          </li>
                                      </ul>
                                    )
                                  :
                                  (
                                      <ul className={`headSidebar__container_content notAuth`}>
                                          <li style={{ animationDelay: "0s" }}>
                                              <NavLink to="/how-it-works"
                                                       onClick={() => {
                                                           //scrollToBlock('linkSection__container');
                                                           closeToggleNavMenu();
                                                       }}
                                              >{t('navbar.howItWorks')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.2s" }}>
                                              <NavLink to="/food" >{t('navbar.food')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.4s" }}>
                                              <NavLink to="/contact-us"
                                                       onClick={() => {
                                                           // scrollToBlock('contactSectionComponent__container');
                                                           closeToggleNavMenu();
                                                       }}
                                              >{t('navbar.contactUs')}</NavLink>
                                          </li>
                                          <li style={{ animationDelay: "0.6s" }}>
                                              <a
                                                onClick={() => handleLogin('registration')}
                                              >
                                                  {t('navbar.signUp')}
                                              </a>
                                          </li>
                                          <li style={{ animationDelay: "0.8s" }}>
                                              <a
                                                onClick={() => handleLogin('login')}
                                              >
                                                  {t('navbar.logIn')}
                                              </a>
                                          </li>
                                      </ul>
                                  )
                            }
                            <div className="headSidebar__container_close">
                                <img
                                  src={process.env.PUBLIC_URL + '/images/close.svg'}
                                  alt="burger menu icon"
                                  onClick={() => toggleNavMenu(false)}
                                />
                            </div>
                        </div>
                    </Drawer>
                </div>
            </div>
            <div className="authNavbar__loginSectionComponent_container">
                <AuthModal
                    authStatus={user.isAuth}
                    isVisible={modalVisible}
                    setIsVisible={(status: boolean) => setModalVisible(status)}
                    handleAuthModal={(authUser: boolean) => handleCloseForm(authUser)}
                    authType={authType}
                    setAuthType={(type: string) => setAuthType(type)}
                />
            </div>
        </div>
    );
};

export default OrderHeadSectionComponent;